module.exports = __webpack_public_path__ + "img/loreto-family.3e3c5e0e.jpg";